import {Component} from '@angular/core';
import {ReporteServices} from '../../services/reporte.services';

@Component({
  selector: 'categorias-widget',
  templateUrl: '../../templates/widgets/categorias.widget.template.html'
})
export class CategoriasWidgetComponent {

  mostrar: boolean = false;
  datos: any[] = [];
  totalVentas: number = 0;
  totalCantidad:number = 0;
  total:any = {
    categoria : "Total",
    valor:0,
    cantidad:0,
    porcentaje:0,
    porcCantidad: 0
  };

  constructor(private rs: ReporteServices) {
  }

  consultar(entidad: number, idEntidad: any, fecha1: string, fecha2: string) {
    this.mostrar = false;
    this.datos = [];
    this.rs.devolverReporteMixVenta(entidad, idEntidad, fecha1, fecha2).subscribe(d => {
      let jDt = JSON.parse(d.data.reporteMixVentas);

      this.totalVentas = jDt.total;
      this.clasificarMix(jDt.items);

      this.mostrar = true;
    });
  }

  consultando(){
    this.mostrar = false;
    this.datos = [];
  }

  ingresarDatos(reporteMixVentas:any){
    let jDt = JSON.parse(reporteMixVentas);

    this.totalVentas = jDt.total;
    this.clasificarMix(jDt.items);


    this.mostrar = true;
  }

  clasificarMix(datos: any) {


    for (let d of datos) {

      let fCat = this.datos.find(c => d.categoria == c.categoria);

      if (fCat) {
        fCat.valor += d.valor;
        fCat.cantidad += d.cantidad;
      } else {
        this.datos.push({
          categoria: d.categoria,
          valor: d.valor,
          cantidad: d.cantidad,
          porcentaje: 0,
          porcCantidad: 0,
        });
      }
      this.totalCantidad += d.cantidad;


    }

    this.datos.map(d => {

      d.porcentaje = d.valor / this.totalVentas * 100;
      d.porcCantidad = d.cantidad / this.totalCantidad * 100;
    });

    this.datos.map(d=>{
      this.total.valor += d.valor;
      this.total.cantidad += d.cantidad;
      this.total.porcentaje += d.porcentaje;
      this.total.porcCantidad += d.porcCantidad;
    });

    this.datos.sort((a: any, b: any) => {
      if (a.categoria < b.categoria)
        return -1;
      else
        return 1;
    });

  }


}
